angular.module('am4').directive('selectOnFocus', function($timeout) {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.bind('focus', function() {
                // ahh timeout, we meet again.
                $timeout(function() {
                    element[0].select();
                });
            });
        }
    };
});


// WEBPACK FOOTER //
// ./src/app/directives/selectOnFocus.js